import { Link } from "react-router-dom";
import { categories } from "@/mocks/categories";

export default function CategoryNav() {
  return (
    <section id="video-categories" className="w-full px-4 md:px-6 py-10 md:py-14 max-w-screen-2xl mx-auto">
      <div className="text-center mb-8">
        <h2 className="text-2xl md:text-3xl font-bold text-foreground-950 mb-3" style={{ fontFamily: "var(--font-heading)" }}>
          视频分类
        </h2>
        <p className="text-sm md:text-base text-foreground-600 max-w-xl mx-auto">
          樱花视频为您精心整理了多个视频分类，包含91视频、97视频、51视频等优质内容，点击分类即可浏览
        </p>
      </div>

      <div className="grid grid-cols-2 sm:grid-cols-3 lg:grid-cols-5 gap-3 md:gap-4">
        {categories.map((cat) => (
          <Link
            key={cat.slug}
            to={`/category/${cat.slug}`}
            className="group flex flex-col items-center gap-3 p-5 md:p-6 rounded-lg bg-background-50 border border-background-200/70 hover:border-primary-300 cursor-pointer transition-all duration-300 hover:bg-background-100/70"
          >
            <div className="w-12 h-12 md:w-14 md:h-14 flex items-center justify-center rounded-full bg-primary-100 group-hover:bg-primary-500 transition-colors duration-300">
              <i className={`${cat.icon} text-xl md:text-2xl text-primary-500 group-hover:text-white transition-colors duration-300`}></i>
            </div>
            <span className="text-sm md:text-base font-semibold text-foreground-950 whitespace-nowrap">
              {cat.name}
            </span>
            <span className="text-xs text-foreground-500 text-center line-clamp-2">
              {cat.description.slice(0, 30)}...
            </span>
          </Link>
        ))}
      </div>
    </section>
  );
}